import { render } from "./create-rule-button.vue?vue&type=template&id=3ec9e245"
import script from "./create-rule-button.vue?vue&type=script&setup=true&lang=js"
export * from "./create-rule-button.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/products/pages/repricing-rules/list/components/create-rule-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3ec9e245"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3ec9e245', __exports__)) {
    console.log('reload')
    api.reload('3ec9e245', __exports__)
  }
  
  module.hot.accept("./create-rule-button.vue?vue&type=template&id=3ec9e245", () => {
    console.log('re-render')
    api.rerender('3ec9e245', render)
  })

}


export default __exports__